module.exports = __webpack_public_path__ + "media/old_images/image-promo-forest-blur-8783fe75.jpg";